import { BaseResponse } from '../../../../../../../types/api/api.types';
import { COMMERCIAL_ENDPOINTS } from '../../../../../../../utils/api/endpoints/commercialEndpoints';
import { DashboardCommerciauxFormSchema } from './DashboardCommerciauxUpdateForm.types';

const PREFIX = '[updateCommercialQuery]';

export const UPDATE_COMMERCIAL_QUERY_KEY = 'UPDATE_COMMERCIAL';

export const updateCommercialQuery = async (
  data: DashboardCommerciauxFormSchema & { id: number }
) => {
  console.log(PREFIX, `Requesting commercial account update...`);
  const response = await COMMERCIAL_ENDPOINTS.update(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received commercial account update response.`);
  return json as BaseResponse;
};
